import { CSSObject } from "@emotion/react";

import { ICON_DEFAULT_STYLE } from "@/shared";

import { colors } from "@dotnet/telematics-design-system";

export const useStyles = (
  isSelected?: boolean,
  isCreateNewSchedule?: boolean,
  isVehiclesSchedule?: boolean
) => {
  const {
    blue100,
    blue200,
    blue400,
    blue700,
    gray100,
    gray200,
    textDark,
    textSecondary,
    white,
    textPlaceholder
  } = colors;

  const scheduleCardTransition = "250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms";

  return {
    dialogContent: {
      alignItems: "center",
      display: "flex",
      columnGap: "4px",
      padding: "0 16px"
    },
    scheduleCards: {
      display: "flex",
      flexWrap: "wrap",
      gap: "16px"
    },

    singleScheduleCard: {
      display: "block",
      alignItems: "center",
      borderRadius: "8px",
      padding: "16px",
      boxSizing: "border-box",
      height: isVehiclesSchedule ? "100%" : "134px",
      border: isCreateNewSchedule
        ? `1px dashed var(--Gray-Gray200, ${gray200})`
        : `1px solid ${gray200}`
    },

    globalScheduleInfo: {
      ...ICON_DEFAULT_STYLE,
      color: textDark,
      display: "flex"
    },
    scheduleTitle: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },

    scheduleCardRows: {
      "> div": {
        display: "flex",
        gridTemplateColumns: "auto auto",
        color: textDark
      },
      "> div:not(:last-child)": {
        paddingBottom: "8px"
      }
    },

    scheduleCardFirstColumn: {
      color: textSecondary,
      width: "88px",
      paddingRight: "4px"
    },
    scheduleCardButtons: {
      display: "flex",
      marginLeft: "auto",
      position: "absolute",
      columnGap: "4px",
      top: "17px",
      right: "17px"
    },

    singleScheduleCardClickable: {
      backgroundColor: isSelected && !isCreateNewSchedule ? blue100 : white,
      transition: `background-color ${scheduleCardTransition}`,
      cursor: "pointer",
      "&:hover": {
        boxShadow: "none",
        backgroundColor: isSelected && !isCreateNewSchedule ? blue200 : gray100
      },

      "&:active": {
        boxShadow: "none",
        backgroundColor: isSelected && !isCreateNewSchedule ? blue400 : blue100
      }
    },

    createNewSchedule: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      color: textPlaceholder,
      ":hover": {
        color: textSecondary,
        transition: `color ${scheduleCardTransition}`
      }
    },

    createNewScheduleIcon: {
      width: "40px",
      height: "40px"
    },

    scheduleActivitiesDates: {
      display: "flex",
      alignItems: "center",
      gap: "12px"
    },

    scheduleIconAndTitle: {
      display: "flex",
      alignItems: "center",
      columnGap: "4px",
      margin: "2px 0 8px 0",
      color: textDark
    },

    infoIconCSS: {
      color: blue700,
      display: "flex"
    },

    typographyTitleIconCSS: {
      display: "flex",
      alignItems: "center",
      columnGap: "4px",
      margin: "8px 0 8px 0"
    },

    downloadActivitiesTitleCSS: {
      display: "flex",
      alignItems: "center",
      columnGap: "4px",
      margin: "4px 0 4px 0"
    },

    scheduleColumnIcon: {
      marginRight: "4px",
      display: "flex",
      alignItems: "center"
    },

    multipleSchedulesIcon: {
      display: "flex",
      alignItems: "center"
    },

    multipleRowsTooltip: { display: "flex", flexDirection: "column" }
  } as CSSObject;
};
